import styled from 'styled-components';

import {prop, range, xprod} from 'ramda';

import {DASHBOARD_TILE_SIZES} from '../../consts/dashboardTileSizes';
import {DashboardTileSize} from '../../types/DashboardTileSize';
import {DASHBOARD_GRID_COLUMNS} from '../../utils/allocateDashboardGrid';

interface DashboardTileSizeShapeProps {
  size: DashboardTileSize;
}

const SHAPE_WIDTH = 10;
const SHAPE_HEIGHT = 5;
const SHAPE_GAP = 1;
// The tallest tile spans two rows, so two rows show every size.
const SHAPE_ROWS = 2;
const FIRST_CELL = 1;

const SHAPE_CELLS = xprod(
  range(FIRST_CELL, SHAPE_ROWS + FIRST_CELL),
  range(FIRST_CELL, DASHBOARD_GRID_COLUMNS + FIRST_CELL)
).map(([row, column]) => ({column, row}));

const StyledShape = styled.div`
  display: grid;
  grid-template-columns: repeat(${DASHBOARD_GRID_COLUMNS}, 1fr);
  grid-template-rows: repeat(${SHAPE_ROWS}, 1fr);
  gap: ${({theme}) => theme.getSize(SHAPE_GAP)};
  width: ${({theme}) => theme.getSize(SHAPE_WIDTH)};
  height: ${({theme}) => theme.getSize(SHAPE_HEIGHT)};
`;

const StyledShapeCell = styled.div<{$isFilled: boolean}>`
  border-radius: ${({theme}) => theme.radii.xSmall};
  background: ${({theme, $isFilled}) =>
    $isFilled ? theme.colors.palettes.blue[80][100] : theme.colors.palettes.neutral[70][40]};
`;

export function DashboardTileSizeShape(props: DashboardTileSizeShapeProps) {
  const {columns, rows} = prop(props.size, DASHBOARD_TILE_SIZES);

  return (
    <StyledShape aria-hidden>
      {SHAPE_CELLS.map((cell) => (
        <StyledShapeCell
          key={`${cell.column}x${cell.row}`}
          $isFilled={cell.column <= columns && cell.row <= rows}
        />
      ))}
    </StyledShape>
  );
}
